export default "__VITE_ASSET__cbc64a21__"